import { render, staticRenderFns } from "./GenderbyLGA.vue?vue&type=template&id=0a9cad8c&"
import script from "./GenderbyLGA.vue?vue&type=script&lang=js&"
export * from "./GenderbyLGA.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports